import { Component, h, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'bot-message-switch-component',
  styleUrl: 'bot-message-switch-module.scss',
  shadow: true,
})
export class ModuleBotMessageSwitch {
  @Prop() readonly message: IWCChatMessage;
  @Prop() readonly subLevel = false;
  @Prop() readonly lastMessage: { total: number; index: number };
  private sendedMessage = '';

  componentWillRender() {
    if (Boolean(this.message?.sender_type)) {
      const { title, sender_type } = this.message;
      this.sendedMessage = title;

      if (sender_type === 'customer') {
        this.sendedMessage = wcShared?.store?.pipes?.escapeHtml(title);
        this.sendedMessage = this.sendedMessage?.replace(/\n\r?/g, '<br/>');
      }
    }
  }

  render() {
    // <Host></Host>,
    if (this.message.type === 'select' || this.message?.type === 'select_service') {
      // Select
      return (
        <chat-message-select-component
          lastMessage={this.lastMessage}
          message={this.message}
        ></chat-message-select-component>
      );
    } else if (this.message.type === 'item_list') {
      // Items list
      return (
        <chat-message-item-list-component message={this.message}></chat-message-item-list-component>
      );
    } else if (this.message.type === 'menu') {
      // Menu
      return (
        <chat-message-menu-component
          lastMessage={this.lastMessage}
          message={this.message}
        ></chat-message-menu-component>
      );
    } else if (this.message.type === 'rating' || this.message.type === 'rating_reply') {
      // Rating
      return (
        <chat-message-rating-component
          lastMessage={this.lastMessage}
          message={this.message}
        ></chat-message-rating-component>
      );
    } else if (this.message.type === 'link') {
      // Link
      const url = this.message?.action as string;
      return <a href={url}>{this.message.title}</a>;
    } else if (this.message.type === 'loading') {
      // Loader Bot writing
      return <chat-message-writing-component></chat-message-writing-component>;
    } else if (this.message.type === 'tips') {
      // Tips
      return <chat-message-tips-component message={this.message}></chat-message-tips-component>;
    } else if (this.message.type === 'faq') {
      // FAQs
      return <chat-message-faqs-component message={this.message}></chat-message-faqs-component>;
    } else if (this.message.type === 'event') {
      // Event
      return <chat-message-event-component message={this.message}></chat-message-event-component>;
    } else if (this.message.type === 'ticket') {
      // Ticket
      return <chat-message-ticket-component message={this.message}></chat-message-ticket-component>;
    } else if (this.message.type === 'contact_menu') {
      // Contact
      return (
        <chat-message-contact-component message={this.message}></chat-message-contact-component>
      );
    } else if (
      this.message.type === 'technical_question_menu' ||
      this.message.type === 'technical_question_menu_reply'
    ) {
      // Connected
      return (
        <chat-message-connected-component
          lastMessage={this.lastMessage}
          message={this.message}
        ></chat-message-connected-component>
      );
    } else if ('documentation' === this.message.type) {
      // Documentation
      return (
        <chat-message-documentation-component
          documentationType={this.message.title}
        ></chat-message-documentation-component>
      );
    } else if ('text_icon' === this.message.type) {
      // Text with icon
      return (
        <chat-message-text-icon-component
          textIconType={this.message.title}
        ></chat-message-text-icon-component>
      );
    } else {
      // Message default
      return (
        <span
          class={{
            'chat-message-text': true,
            'chat-message-text--right': this.message?.sender_type === 'customer',
          }}
          innerHTML={this.sendedMessage}
        ></span>
      );
    }
  }
}
